var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buyev"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"buyev-content"},[_c('i',{staticClass:"icon-confetti"}),_c('a',{attrs:{"href":"https://buyev.tw"}},[_vm._v("二手電動車買賣平台")])])])])
}]

export { render, staticRenderFns }